import moment from "moment";
import TypesUtils from "./typesUtils";

const DATE_TIME_FORMAT_MYSQL = "YYYY-MM-DDTHH:mm:ss";
const DATE_TIME_FORMAT_ISO8601 = "YYYY-MM-DD HH:mm";
const DATE_TIME_FORMAT_ISO8601_EX = "YYYY-MM-DD HH:mm:ss";
const DATE_TIME_FORMAT_FULL_ISO8601_EX = "YYYY-MM-DD HH:mm:ss.SSS";
const DATE_FORMAT_ISO8601_EX = "YYYY-MM-DD";
const DATE_TIME_LATIN_FORMAT = "DD/MM/YYYY HH:mm";
const DATE_LATIN_FORMAT = "DD/MM/YYYY";

class DateUtils {

    static getStrTime(date, format = "HH:mm") {
        if (TypesUtils.isStr(date)) return date;
        if (date instanceof Date)
            return (
                ("0" + date.getHours()).slice(-2) +
                ":" +
                ("0" + date.getMinutes()).slice(-2)
            );
        else if (date.format) return date.format(format);
        return;
    }

    static getDay(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        if (date instanceof Date) return date.getDay();
        let dateAux = date;
        if (TypesUtils.isStr(dateAux)) dateAux = this.parseDate(date, format);
        else if (dateAux.format) return dateAux.format("DD");
        return;
    }

    static getHour(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let dateAux = this.momentDate(date,format)
        return dateAux.format("HH");
    }

    static sameHour(date1, date2, format = DATE_TIME_FORMAT_ISO8601_EX) {
        return DateUtils.getHour(date1, format) === DateUtils.getHour(date2, format);
    }

    static parseDate(strDate, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let date = moment.utc(strDate, format, false);
        if (date.isValid()) return date;
        return null;
    }

    static validateStrDate(strDate, format = DATE_TIME_FORMAT_ISO8601){
        let date = moment.utc(strDate, format, true);
        if (date.isValid()) return date;
        return null;
    }

    static parseDateLT(strDate, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let date = moment(strDate, format, false);
        if (date.isValid()) return date;
        return null;
    }

    static dateToStr(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        return DateUtils.momentDate(date).format(format);
    }

    static changeFormat(
        strDate,
        inFormat = DATE_TIME_FORMAT_MYSQL,
        outFormat = DATE_TIME_LATIN_FORMAT
    ) {
        if (strDate) return DateUtils.momentDate(strDate, inFormat).format(outFormat);
        return "";
    }

    static toMySQLStr(date){
        return DateUtils.momentDate(date).format(DATE_TIME_FORMAT_MYSQL);
    }

    static toISO8601(date){
        return DateUtils.momentDate(date).format(DATE_TIME_FORMAT_ISO8601);
    }


    /**
     *
     * @param {string|JS Date|moment} date Si es un string lo intentara parsear y crear un objeto moment. Si es un objeto Date de JS
     * creara un objeto moment a partir de el mismo en UTC. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string} format Formato de la fecha, para caso string.
     */
    static momentDate(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        if (!date) return null;
        if (TypesUtils.isStr(date)) {
            date = DateUtils.parseDate(date, format);
        } else if (moment.isMoment(date))
            return date
        else
            return moment.utc(date);
        return date;
    }

        /**
     *
     * @param {string|JS Date|moment} date Si es un string lo intentara parsear y crear un objeto moment. Si es un objeto Date de JS
     * creara un objeto moment a partir de el mismo en UTC. Si es otro objeto moment se retorna un objeto moment con la fecha y
     * hora del objeto dado pero en LT.
     * @param {string} format Formato de la fecha, para caso string.
     */
    static momentDateLT(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        if (!date) return null;
        if (TypesUtils.isStr(date)) {
            date = DateUtils.parseDateLT(date, format);
        } else if (moment.isMoment(date))
            return moment(date.format(DATE_TIME_FORMAT_FULL_ISO8601_EX))
        else
            return moment(date);
        return date;
    }


    /**
     * Retorna la cantidad de segundos entre la fecha from y la fecha to. Si from es menor que to retorna
     * los segundos desde to a from por -1. El valor retornado es un float con presicion hasta los milisegundos.
     *
     * @param {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string|JS Date|moment} to Fecha hasta. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string} format Formato de la fecha, para caso string.
     */
    static secondsBetween(from, to, format = DATE_TIME_FORMAT_ISO8601_EX) {
        return this.timeBetween(from,to,'seconds',format)
    }

    /**
     * Retorna la cantidad de minutos entre la fecha from y la fecha to. Si from es menor que to retorna
     * los minutos desde to a from por -1. El valor retornado es un float con presicion hasta los milisegundos.
     *
     * @param {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string|JS Date|moment} to Fecha hasta. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string} format Formato de la fecha, para caso string.
     */
    static minBetween(from, to,  format = DATE_TIME_FORMAT_ISO8601_EX) {
        return this.timeBetween(from,to,'minutes',format)
    }

    /**
     * Retorna un la cantidad de horas entre la fecha from y la fecha to. Si from es menor que to retorna
     * los horas desde to a from por -1. El valor retornado es un float con presicion hasta los milisegundos.
     *
     * @param {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string|JS Date|moment} to Fecha hasta. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string} format Formato de la fecha, para caso string.
     */
    static hoursBetween(from, to, format = DATE_TIME_FORMAT_ISO8601_EX) {
        return this.timeBetween(from,to,'hours',format)
    }

    /**
     * Retorna la cantidad de tiempo en la unidad dada entre la fecha from y la fecha to. Si from es menor que to retorna
     * la cantidad de tiempo en la unidad dada desde to a from por -1.
     * El valor retornado es un float con presicion hasta los milisegundos.
     *
     * @param {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string|JS Date|moment} to Fecha hasta. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {string} format Formato de la fecha, para caso string.
     */
    static timeBetween(from, to, unit, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let dateFrom = DateUtils.momentDate(from, format);
        let dateTo = DateUtils.momentDate(to, format);
        return moment.duration(dateTo.diff(dateFrom)).as(unit);
    }

    static minsFromNowUTC(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let dateAux = this.momentDate(date,format)
        return moment.duration(dateAux.diff(DateUtils.nowUTC())).asMinutes();
    }

    static minsFromNowLT(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let dateAux = this.momentDateLT(date,format)
        return moment.duration(dateAux.diff(DateUtils.nowLT())).asMinutes();
    }

    static hoursFromNow(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let dateAux = this.momentDate(date,format)
        return moment.duration(dateAux.diff(DateUtils.nowLT())).asHours();
    }

    static hoursFrom(date1, date2, format1 = DATE_TIME_FORMAT_ISO8601_EX,format2 = DATE_TIME_FORMAT_ISO8601_EX ) {
        let dateAux1 = this.momentDate(date1,format1)
        let dateAux2 = this.momentDate(date2,format2)
        return moment.duration(dateAux2.diff(dateAux1)).asHours();
    }

    static nowLT() {
        return DateUtils.momentDateLT(new Date());
    }

    static nowUTC() {
        return moment.utc(new Date());
    }

    static nowLTStr(format = DATE_TIME_FORMAT_ISO8601_EX) {
        return this.dateToStr(this.nowLT(), format);
    }

    static nowUTCStr(format = DATE_TIME_FORMAT_ISO8601_EX) {
        return this.dateToStr(DateUtils.nowUTC(), format);
    }

    static todayLTStr(format = DATE_FORMAT_ISO8601_EX) {
        return this.dateToStr(this.nowLT(), format);
    }

    static gtThanNowUTC(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let mDate = DateUtils.momentDate(date, format);
        if (!mDate) return null;
        return DateUtils.hoursFrom(DateUtils.nowUTC(), mDate) > 0;
    }

    static gtThanNowLT(date, format = DATE_TIME_FORMAT_ISO8601_EX) {
        let mDate = DateUtils.momentDateLT(date, format);
        if (!mDate) return null;
        return DateUtils.hoursFrom(DateUtils.nowLT(),mDate) > 0;
    }

    static same(date1,date2,format1 = DATE_TIME_FORMAT_ISO8601_EX,format2=DATE_TIME_FORMAT_ISO8601_EX){
        let mDate1= this.momentDate(date1,format1);
        let mDate2= this.momentDate(date2,format2);
        return mDate1.isSame(mDate2)
    }

    static compareDates(date1,date2){
        let mDate1= this.momentDate(date1);
        let mDate2= this.momentDate(date2);
        let mins= this.minBetween(mDate1,mDate2)
        if (mins > 0) return -1;
        return mins < 0 ? 1 : 0;
    }

    /**
     * Compara las dos fechas dadas tomando en cuenta hasta los minutos, es decir que si la diferencia entre
     * las mismas esta en los segundos o milisegundos retornara 0 (iguales).
     *
     * @param {*} date1 {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {*} date2 {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @return -1 si date1 < date2, 0 si son iguales, 1 si date1 > date2
     */
    static truncToMinsAndCompare(date1,date2){
        let mDate1= this.momentDate(date1).startOf('minute');
        let mDate2= this.momentDate(date2).startOf('minute');
        let mins= this.minBetween(mDate1,mDate2)
        if (mins > 0) return -1;
        return mins < 0 ? 1 : 0;
    }

    static truncTo10Min(date){
        let mDate= this.momentDate(date).startOf('minute');
        let mins= mDate.minutes();
        let mins10 =  Math.floor(mins/10) * 10;
        mDate.set('minute',mins10);
        return mDate;
    }

    /**
     * Compara las dos fechas dadas
     *
     * @param {*} date1 {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @param {*} date2 {string|JS Date|moment} from Fecha desde. Si es un string lo intentara parsear y crear un objeto moment.
     * Si es un objeto Date de JS creara un objeto moment a partir de el mismo. Si es otro objeto moment se retorna el mismo objeto.
     * @return -1 si date1 < date2, 0 si son iguales, 1 si date1 > date2
     */
    static compareStrDates(
        strDate1,
        strDate2,
        formatDate1 = DATE_TIME_FORMAT_ISO8601_EX,
        formatDate2 = DATE_TIME_FORMAT_ISO8601_EX
    ) {
        let date1 = this.momentDate(strDate1, formatDate1);
        let date2 = this.momentDate(strDate2, formatDate2);
        let mins= this.minBetween(date1,date2)
        if (mins > 0) return -1;
        return mins < 0 ? 1 : 0;
    }

    static isoToLatin(date){
        return this.changeFormat(date,DATE_TIME_FORMAT_ISO8601,DATE_TIME_LATIN_FORMAT)
    }

    static latinDT(date){
        return this.dateToStr(date,DATE_TIME_LATIN_FORMAT);
    }

    static latinD(date){
        return this.dateToStr(date,DATE_LATIN_FORMAT);
    }

    static add(date, amount, unit){
        let dateAux
        if (!moment.isMoment(date))
            dateAux= this.momentDate(date)
        else
            dateAux= date.clone();
        return dateAux.add(amount,unit);
    }

    static addMinutes(date, minutes){
        return this.add(date,minutes,'minute')
    }

    static addHours(date, hours){
        return this.add(date,hours,'hour')
    }

    static addDays(date, days){
        return this.add(date,days,'day')
    }

    static addWeeks(date, weeks){
        return this.add(date,weeks,'week')
    }

    static addMonths(date, months){
        return this.add(date,months,'month')
    }

    static addYears(date, years){
        return this.add(date,years,'year')
    }

    static isValidMomentDate(date){
        return moment.isMoment(date);
    }
}

export {
    DateUtils as default,
    DATE_TIME_LATIN_FORMAT,
    DATE_TIME_FORMAT_ISO8601,
    DATE_LATIN_FORMAT,
    DATE_TIME_FORMAT_FULL_ISO8601_EX,
    DATE_TIME_FORMAT_MYSQL
};
